// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconClose(Props) {
  var className = Props.className;
  var tmp = {
    height: "12",
    width: "12",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M 6.877 6.142 L 11.332 1.687 C 11.372 1.647 11.372 1.581 11.332 1.541 L 10.744 0.954 C 10.704 0.913 10.638 0.913 10.597 0.954 L 6.142 5.408 L 1.688 0.954 C 1.647 0.913 1.582 0.913 1.541 0.954 L 0.953 1.541 C 0.913 1.581 0.913 1.647 0.953 1.687 L 5.408 6.142 L 0.953 10.597 C 0.913 10.638 0.913 10.703 0.953 10.744 L 1.541 11.332 C 1.582 11.372 1.647 11.372 1.688 11.332 L 6.142 6.877 L 10.597 11.332 C 10.638 11.372 10.704 11.372 10.744 11.332 L 11.332 10.744 C 11.372 10.703 11.372 10.638 11.332 10.597 Z",
    fill: "currentColor"
  }));
}
IconClose.displayName = "IconClose";
var make = React.memo(IconClose);
export { make };
/* make Not a pure module */